import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import type { AiCampaignDeliveryDto } from '@/shared/api/ai-campaigns';

const STATUS_TONE: Record<string, 'default' | 'primary' | 'success' | 'warning' | 'error'> = {
  queued: 'default',
  reserved: 'warning',
  published: 'primary',
  delivered: 'success',
  read: 'success',
  blocked: 'error',
  skipped: 'warning',
  failed: 'error',
  cancelled: 'default',
};

export function CampaignDeliveryStatus({
  deliveries,
}: {
  deliveries: AiCampaignDeliveryDto[];
}) {
  if (deliveries.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        Доставки появятся после подготовки кампании.
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ maxHeight: 320 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Получатель</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Сообщение</TableCell>
            <TableCell>Ошибка</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deliveries.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell>
                <Typography variant="body2" fontWeight={700}>
                  {item.recipient.name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.chat_id}
                </Typography>
              </TableCell>
              <TableCell>
                <Chip
                  size="small"
                  color={STATUS_TONE[item.status] ?? 'default'}
                  variant="outlined"
                  label={item.status}
                  sx={{ borderRadius: 1 }}
                />
              </TableCell>
              <TableCell sx={{ maxWidth: 340 }}>
                <Typography variant="body2" noWrap title={item.message_preview}>
                  {item.message_preview}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="caption" color="text.secondary">
                  {item.last_error || '—'}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
